module.exports = __webpack_public_path__ + "static/media/sustainable-solar.eb23cbbf.jpg";